import { render, staticRenderFns } from "./newsDelete.vue?vue&type=template&id=c72b506c&"
import script from "./newsDelete.vue?vue&type=script&lang=js&"
export * from "./newsDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports